import React from 'react';

function Cards() {
    return (
        <div className='cards'>
            <h1>Bolsas</h1>
            <div class="container">
                <div class="card">
                    <div class="img">
                        <img src="images/bolsa-em-croche-azul.jpg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="images/bolsaverde.jpeg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="images/bolsacolorida.jpeg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="images/bolsaestilo.jpg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="images/bolsaflorida.jpeg" alt='' />
                    </div>
                    <div class="content">
                    </div>
                </div>
                <div class="card">
                    <div class="img">
                        <img src="images/bolsapreta.webp" alt='' />
                    </div>
                    <div class="content">
                    </div>
                </div>
                <div class="container">
                    <div class="card">
                        <div class="img">
                            <img src="images/bolsaredonda.jpeg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/bolsarosa.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/bolsas.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/bolsaverao.jpeg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/6.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/bolsaesmeralda.webp" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                </div>
                <h1>Artigos infantis</h1>
                <div class="container">
                    <div class="card">
                        <div class="img">
                            <img src="images/conjuntopraia.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/sapatinho.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/sapatinhoo.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/vestido.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/1.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/2.png" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                </div>
                <h1>Artigos Decoração</h1>
                <div class="container">
                    <div class="card">
                        <div class="img">
                            <img src="images/ninho.jpeg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/portaflor.jpeg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/portaxicara.jpeg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/cesto-croche.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/cesto.jpg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="images/cestoamarelo.jpeg" alt='' />
                        </div>
                        <div class="content">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cards;

